/**
 * @fileoverview Página responsável pela experiência principal de tickets em layout de múltiplos painéis.
 */

import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import MainContainer from "../../components/MainContainer";
import DynamicLogo from "../../components/DynamicLogo";
import ResizableSplitView from "../../components/ResizableSplitView";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		padding: 0,
		height: "100%",
		minHeight: 0,
		minWidth: 0,
		overflow: "hidden",
		position: "sticky",
		top: 0,
	},

	chatPapper: {
		display: "flex",
		flex: 1,
		height: "100%",
		overflow: "hidden",
		alignItems: "stretch",
		position: "relative",
	},

	messagesWrapper: {
		background: theme.palette.type === 'light'
			? '#ffffff'
			: 'radial-gradient(ellipse 100% 100% at 50% 50%, #1A1A1A 0%, #1A1A1A 35%, #161618 60%, #121214 75%, #0E0E0F 85%, #0A0A0A 100%)',
	},
	welcomeMsg: {
		background: theme.palette.type === 'light'
			? '#ffffff'
			: 'radial-gradient(ellipse 100% 100% at 50% 50%, #1A1A1A 0%, #1A1A1A 35%, #161618 60%, #121214 75%, #0E0E0F 85%, #0A0A0A 100%)',
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		border: 'none',
		boxShadow: 'none',
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const history = useHistory();
	const { user } = useContext(AuthContext);

	useEffect(() => {
		if (!ticketId) return;
		const onKey = (e) => {
			if (e.key !== "Escape") return;
			const t = e.target;
			const typing =
				t?.isContentEditable ||
				["INPUT", "TEXTAREA"].includes(t?.tagName);
			if (typing) return;
			if (document.querySelector(".MuiDialog-root")) return;
			history.push("/tickets");
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [ticketId, history]);

	return (
		<MainContainer>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<ResizableSplitView
						primaryId="tickets-list-panel"
						storageKey={`tickets:list-width:${user.companyId}:${user.id}`}
						separatorLabel={i18n.t("tickets.splitter.label")}
						separatorHint={i18n.t("tickets.splitter.hint")}
						primary={<TicketsManager />}
						secondaryClassName={classes.messagesWrapper}
						secondary={ticketId ? <Ticket /> : (
							<div className={classes.welcomeMsg}>
								<div>
									<center><DynamicLogo style={{ margin: "0 auto", width: "70%" }} alt="logo" /></center>
								</div>
							</div>
						)}
					/>
				</div>
			</div>
		</MainContainer>
	);
};

export default TicketsCustom;
